module.exports = __webpack_public_path__ + "static/media/Media2.a977d21e.jpg";